import {Injectable} from '@angular/core';
import {AudioTranscriptionDataService} from "./audioTranscriptionData.service";
import {
    AbstractDataServiceDtoAdapter
} from "../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";
import {AudioTranscriptionModel} from "../../../api/model/audioTranscription.model";
import {AudioTranscriptionConverter} from "../../../api/model/converter/audioTranscription.converter";

@Injectable({
    providedIn: 'root'
})
export class AudioTranscriptionDataServiceAdapter extends AbstractDataServiceDtoAdapter<AudioTranscriptionModel, AudioTranscriptionConverter> {
    constructor(dataService: AudioTranscriptionDataService, converter: AudioTranscriptionConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): AudioTranscriptionModel {
        return new AudioTranscriptionModel();
    }
}
